<script lang="ts">
	import { onMount } from 'svelte';
	import { footerSections, DASHBOARD_URL } from "./footer-links";
	import type { FooterSection } from "./footer-links";
	import { isDashboardAuthenticated } from '$lib/utils/auth-cookie';
	import Logo from "./logo.svelte";

	let currentYear = $state(2026);
	let dashboardAuth = $state(false);

	const accountSection = $derived<FooterSection>(
		dashboardAuth
			? {
					title: 'Account',
					links: [
						{ href: DASHBOARD_URL, label: 'Dashboard', external: true },
					]
				}
			: {
					title: 'Account',
					links: [
						{ href: `${DASHBOARD_URL}/sign-in`, label: 'Sign In', external: true },
						{ href: `${DASHBOARD_URL}/sign-up`, label: 'Sign Up', external: true },
					]
				}
	);

	const allSections = $derived([...footerSections, accountSection]);

	onMount(() => {
		currentYear = new Date().getFullYear();
		dashboardAuth = isDashboardAuthenticated();
	});
</script>

<footer class="mt-auto border-t bg-white">
	<div class="container mx-auto px-4 py-8 md:py-12">
		<div class="mb-8 border-b border-gray-100 pb-8 md:mb-10 md:border-0 md:pb-0">
			<div class="flex flex-col items-center gap-3 md:flex-row md:gap-0">
				<a href="/" class="inline-flex items-center gap-2">
					<Logo />
					<span class="text-base font-bold text-gray-900">Talent<strong>Profile</strong></span>
				</a>
				<p class="text-center text-sm text-gray-600 md:ml-auto md:text-right">
					AI-powered tech job matching.<br class="sm:hidden" /> Free forever.
				</p>
			</div>
		</div>

		<div class="grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-3 md:gap-x-8 lg:grid-cols-6">
			{#each allSections as section (section.title)}
				<div>
					<h3 class="mb-3 text-xs font-semibold uppercase tracking-wider text-gray-900 md:mb-4 md:text-sm md:normal-case md:tracking-normal">
						{section.title}
					</h3>
					<ul class="space-y-2 md:space-y-2.5">
						{#each section.links as link (link.href)}
							<li>
								<a
									href={link.href}
									data-sveltekit-preload-data={link.external ? undefined : 'hover'}
									target={link.external ? '_blank' : undefined}
									rel={link.external ? 'noopener noreferrer' : undefined}
									class="inline-block py-0.5 text-sm text-gray-600 transition-colors hover:text-blue-600"
								>
									{link.label}
								</a>
							</li>
						{/each}
					</ul>
				</div>
			{/each}
		</div>

		<div class="mt-8 flex flex-col items-center gap-3 border-t border-gray-200 pt-6 md:mt-10 md:flex-row md:justify-between md:pt-8">
			<p class="text-xs text-gray-500 md:text-sm">
				© {currentYear} TalentProfile. All rights reserved.
			</p>
			<p class="text-xs text-gray-500 md:text-sm">
				Made with ❤️ for developers
			</p>
		</div>
	</div>
</footer>